import { render, staticRenderFns } from "./DialogAlterarEmMassa.vue?vue&type=template&id=d45d2c12&scoped=true"
import script from "./DialogAlterarEmMassa.vue?vue&type=script&lang=js"
export * from "./DialogAlterarEmMassa.vue?vue&type=script&lang=js"
import style0 from "./DialogAlterarEmMassa.vue?vue&type=style&index=0&id=d45d2c12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d45d2c12",
  null
  
)

export default component.exports